import React from 'react';
import { Link } from '@nackle/biw-web-router';
import { Breadcrumb } from 'antd';

/**
 * Shared breadcrumb renderer used by BOTH the <Breadcrumbs> component and the
 * legacy buildPageHeaderBreadcrumb() helper, so every breadcrumb in the app
 * renders identical markup (and therefore the same hover behaviour).
 *
 * @param { Array<{ name: string, path?: string }> } crumbs
 *   Each crumb becomes a link when it has a `path`, otherwise plain text
 *   (the current page is intentionally not a link).
 * @returns a rendered antd <Breadcrumb> element.
 */
export const renderBreadcrumb = ( crumbs = [] ) => (
    <Breadcrumb>
        { crumbs.map( ( crumb, index ) => (
            <Breadcrumb.Item key={ index }>
                { crumb.path
                    ? <Link to={ crumb.path }>{ crumb.name }</Link>
                    : crumb.name
                }
            </Breadcrumb.Item>
        ) ) }
    </Breadcrumb>
);
